import React, {Component} from 'react';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {Icon} from "./Icon";

class Btn extends Component {
    render() {
        const {children, onClick, small, disabled, primary, secondary, buttonType, value, help, icon, type, save, danger, compact} = this.props;

        return (
            <button
                className={classNamesPrefixed({
                    'btn': true,
                    'btn--primary': primary ? true : false,
                    'btn--secondary': secondary ? true : false,
                    'btn--small': small ? true : false,
                    'btn--disabled': disabled ? true : false,
                    'btn--save': save ? true : false,
                    'btn--danger': danger ? true : false,
                    'btn--compact': compact ? true : false,
                    'btn--icon': icon && !children
                })}
                disabled={disabled}
                onClick={onClick}

                type={buttonType}
                value={value}
                title={help}
            >
                {icon && icon.length > 0 &&
                <Icon value={value} name={icon} type={type ? type : 'fa'}/>
                }
                {children}
            </button>
        );
    };
}

export default Btn;



// WEBPACK FOOTER //
// ./src/core/admin/components/UI/Btn.js